const languages = {
  en_UK: {
    'EN': 'EN',
    'CN': 'CN',
    'JP': 'JP',
    'KP': 'KP',
    'PT': 'PT',
    'RU': 'RU',
    'AE': 'AE',
    'TH': 'TH',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': 'Ready to start? Add the Training App to your home screen in a few\neasy steps.',
    'Tap On': 'Tap On',
    'in your browser toolbar': 'in your browser toolbar',
    'Scroll through the options and choose': 'Scroll through the options and choose',
    '“Add to Home Screen”': '“Add to Home Screen”',
    'Tap “Add” and the icon will appear on your Home Screen.': 'Tap “Add” and the icon will appear on your Home Screen.',
    'For the best experience, open this link on your iPad':'For the best experience, open this link on your iPad',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': 'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.'
  },
  it_IT: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': 'Pronto per iniziare? Aggiungi la Training App alla schermata Home in pochi semplici passaggi',
    'Tap On': 'Tocca',
    'in your browser toolbar': 'nella barra degli strumenti del tuo browser',
    'Scroll through the options and choose': 'Scorri tra le opzioni e seleziona',
    '“Add to Home Screen”': '“Aggiungi a schermata Home”',
    'Tap “Add” and the icon will appear on your Home Screen.': 'Tocca “Aggiungi” e l’icona apparirà nella tua schermata Home',
    'For the best experience, open this link on your iPad': 'Per un’esperienza ottimale, apri questo link su iPad',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': 'Potrai aggiungere la Training App alla schermata Home per un accesso diretto, esclusivo ed immediato a tutti i nostri contenuti'
  },
  fr_FR: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': 'Prêt(e) à commencer ? Ajoutez la Training App à votre page d\'accueil en quelques simples passages',
    'Tap On': 'Cliquez',
    'in your browser toolbar': 'dans la barre des outils de votre navigateur',
    'Scroll through the options and choose': 'Parcourez les options et sélectionnez',
    '“Add to Home Screen”': '« Ajouter à la page d\'accueil »',
    'Tap “Add” and the icon will appear on your Home Screen.': 'Toucher « Ajouter » et l\'icône apparaîtra sur votre page d\'accueil',
    'For the best experience, open this link on your iPad': 'Pour une expérience optimale, ouvrez ce lien sur iPad',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': 'Vous pourrez ajouter la Training App à la page d\'accueil pour un accès direct, exclusif et immédiat à tous nos contenus'
  },
  es_ES: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': '¿Listo para empezar? Añade la Training App a tu pantalla de inicio en unos sencillos pasos',
    'Tap On': 'Pulsa',
    'in your browser toolbar': 'en la barra de herramientas de tu navegador',
    'Scroll through the options and choose': 'Desplázate por las opciones y selecciona',
    '“Add to Home Screen”': '«Añadir a la pantalla de inicio»',
    'Tap “Add” and the icon will appear on your Home Screen.': 'Pulsa «Añadir» y el icono aparecerá en tu pantalla de inicio',
    'For the best experience, open this link on your iPad': 'Para disfrutar de la mejor experiencia, abre este enlace en tu iPad',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': 'Podrás añadir la Training App directamente a tu pantalla de inicio, lo que te garantizará un acceso privilegiado e instantáneo a todo nuestro contenido'
  },
  pt_PT: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': 'Preparado para começar? Adicione o aplicativo de treinamento à sua tela inicial em poucas etapas',
    'Tap On': 'Toque',
    'in your browser toolbar': 'na barra de ferramentas do seu navegador',
    'Scroll through the options and choose': 'Role a tela pelas opções e selecione',
    '“Add to Home Screen”': '“Adicionar à tela inicial”',
    'Tap “Add” and the icon will appear on your Home Screen.': 'Toque em “Adicionar”. O ícone do aplicativo será exibido na sua tela inicial',
    'For the best experience, open this link on your iPad': 'Para ter a melhor experiência, abra este link no seu iPad',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': 'Você poderá adicionar o aplicativo de treinamento à sua tela inicial e, com isso, garantirá acesso privilegiado e instantâneo a todo o nosso conteúdo'
  },
  de_DE: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': 'Sind Sie bereit? Fügen Sie die Trainings-App mit wenigen einfachen Schritten in Ihren Startbildschirm ein',
    'Tap On': 'Klicken Sie auf',
    'in your browser toolbar': 'in der Toolbar Ihres Browsers',
    'Scroll through the options and choose': 'Scrollen Sie durch die Optionen und wählen Sie',
    '“Add to Home Screen”': '“In den Startbildschirm einfügen“',
    'Tap “Add” and the icon will appear on your Home Screen.': '“Einfügen” anklicken und die Ikone erscheint auf Ihrem Startbildschirm',
    'For the best experience, open this link on your iPad': 'Öffnen Sie für ein optimales Erlebnis diesen Link auf Ihrem iPad',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': 'Sie können die Trainings-App direkt in Ihren Startbildschirm einfügen und erhalten so privilegierten und sofortigen Zugriff auf alle unsere Inhalte'
  },
  ja_JP: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': '始める準備はできましたか？数ステップで簡単にホーム画面にトレーニングアプリを追加してください。',
    'Tap On': 'ブラウザのツールバーの',
    'in your browser toolbar': 'をタップしてください',
    'Scroll through the options and choose': 'オプションをスクロールし',
    '“Add to Home Screen”': '「ホーム画面に追加」を選択してください',
    'Tap “Add” and the icon will appear on your Home Screen.': '「追加」をタップすると、ホーム画面にアイコンが表示されます。',
    'For the best experience, open this link on your iPad': '最高の体験をするためには、このリンクをiPadで開いてください',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': 'トレーニングアプリをホーム画面に直接追加すると、すべてのコンテンツに優先的かつ直ちにアクセスできるようになります。'
  },
  ko_KR: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': '시작할 준비가 되셨나요? 홈 화면에 트레이닝 앱을 추가하세요. 어렵지 않습니다.',
    'Tap On': '브라우저 도구 모음에서',
    'in your browser toolbar': '를 누르세요',
    'Scroll through the options and choose': '옵션을 스크롤하여',
    '“Add to Home Screen”': '“홈 화면에 추가”를 선택하세요',
    'Tap “Add” and the icon will appear on your Home Screen.': '“추가”를 누르면 홈 화면에 아이콘이 나타납니다.',
    'For the best experience, open this link on your iPad': '최상의 경험을 위해서는 iPad에서 링크를 여십시오',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': '트레이닝 앱을 홈 화면에 추가하면 모든 콘텐츠를 빠르게 만나보실 수 있습니다.'
  },
  zh_CN: {
    'EN': 'EN',
    'IT': 'IT',
    'FR': 'FR',
    'ES': 'ES',
    'PT': 'PT',
    'DE': 'DE',
    'JP': 'JP',
    'KR': 'KR',
    'CN': 'CN',
    'Ready to start? Add the Training App to your home screen in a few easy steps.': '准备好了吗？只需几个简单步骤，即可把训练应用添加到你的主屏幕。',
    'Tap On': '在浏览器工具栏点击',
    'in your browser toolbar': '를 누르세요',
    'Scroll through the options and choose': '在选项列表中找到并选择',
    '“Add to Home Screen”': '“添加到主屏幕”',
    'Tap “Add” and the icon will appear on your Home Screen.': '单击“添加”，图标将出现在你的主屏幕上。',
    'For the best experience, open this link on your iPad': '为获得最佳体验，请在 iPad 上打开此链接',
    'You\'ll be able to add the Training App directly to your Home screen, ensuring privileged and instant access to all our content.': '你将能直接将训练应用添至主屏幕，享受优先且即时访问我们所有内容的便利。'
  },
};

function translate(key, language) {
  return languages[language] && languages[language][key]
    ? languages[language][key]
    : key; // @todo 2019-05-23 Consider using UK as default instead of the key translate(key, 'en_UK')
}

export default function __(text, attributes = {}) {

  const langCode = localStorage.getItem("languageCode") || "en_UK"; // fallback default

  return translate(text, langCode).replace(/:(\w+)/g, (match, attribute) => {
    return attributes[attribute];
  });
};
